import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export interface AuditEntry {
  id: string;
  action: string;
  resourceType?: string | null;
  resourceId?: string | null;
  newValue?: Record<string, any> | null;
  ipAddress?: string | null;
  createdAt: string;
  user?: { id: string; name: string; email: string } | null;
}

export function useAuditLog() {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [action, setAction] = useState('');

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/audit', { params: { action: action || undefined, limit: 200 } });
      setEntries(res.data.entries ?? []);
      setTotal(res.data.total ?? 0);
    } catch {
      /* silent */
    } finally {
      setLoading(false);
    }
  }, [action]);

  useEffect(() => { refetch(); }, [refetch]);

  return { entries, total, loading, action, setAction, refetch };
}
